import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';

export function SectionBackToTopBtn({ className = null, styles = null }) {
  return (
    <Button
      tag={ScrollLink}
      to="article-top"
      color="link"
      aria-hidden
      data-testid="section-back-to-top-btn"
      className={classnames('section-back-to-top-btn size-14 text-capitalize text-primary-darker p-0', className)}
      style={styles}
    >
      Back to the top <span className="icon-arrow-up3 d-inline-block ms-0_25" aria-hidden />
    </Button>
  );
}

SectionBackToTopBtn.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.shape({}),
};
